export default __webpack_public_path__ + "static/media/o.e3756fe4.svg";